'use client';
import { useEffect } from 'react';
import { useSessionGuardStore } from '@/stores/sessionGuardStore';

const EVENTS = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'] as const;

export function useActivityTracker(): void {
  useEffect(() => {
    const recordActivity = useSessionGuardStore.getState().actions.recordActivity;
    let lastFired = 0;
    const handler = () => {
      const now = Date.now();
      if (now - lastFired < 250) return;
      lastFired = now;
      recordActivity();
    };
    EVENTS.forEach((e) => window.addEventListener(e, handler, { passive: true }));
    return () => EVENTS.forEach((e) => window.removeEventListener(e, handler));
  }, []);
}
